import { faUserEdit } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DialogContent, Grid } from '@mui/material';
import { UpdateRolesForm } from 'components/Form';
import { CustomActionButtons } from 'components/Modals/_CustomActionButtons';
import { ModalHeader } from 'components/Modals/ModalHeader';
import PropTypes from 'prop-types';
import React from 'react';
import { useForm } from 'react-hook-form';
import { translate } from 'utils/helpers';

export const UpdateRolesModal = ({
                                   onClose, onConfirm, closeOnSubmit, defaultValues, accessibleRolesByStructureLevel
                                 }) => {
  const { handleSubmit, control, watch } = useForm({
    defaultValues: {
      roles: defaultValues.roles
    }
  });
  const roles = watch('roles');
  const onSubmit = data => {
    onConfirm(data.roles);
    if (closeOnSubmit) {
      onClose();
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <ModalHeader onClose={onClose}>
        <Grid alignItems="center" container justifyContent="space-between">
          <div>
            <FontAwesomeIcon icon={faUserEdit} />
            {`${translate('modalUserUpdate.editUser')} : ${defaultValues.person.firstName} ${defaultValues.person.lastName}`}
          </div>
        </Grid>
      </ModalHeader>

      <DialogContent style={{ width: '50vw', padding: '10px' }}>
        <UpdateRolesForm
              accessibleRolesByStructureLevel={accessibleRolesByStructureLevel}
              control={control}
              formState={{ values: { roles }, setField: (field, value) => control._formValues[field] = value }}
              initialRoles={defaultValues.roles}
          />
      </DialogContent>

      <CustomActionButtons
            isValidated={defaultValues.person.validated}
            onClose={onClose}
        />
    </form>
  );
};

UpdateRolesModal.propTypes = {
  closeOnSubmit: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  defaultValues: PropTypes.shape({
    roles: PropTypes.array.isRequired,
    person: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      validated: PropTypes.bool
    })
  }).isRequired,
  accessibleRolesByStructureLevel: PropTypes.array
};

UpdateRolesModal.defaultProps = {
  closeOnSubmit: true,
  accessibleRolesByStructureLevel: []
};
